<template>
  <v-app>
    <div class="grid">
      <div class="grid-title">
        <h4>{{ $t("_ACTIVITY.HOTEL_UPDATE_PAYMENT_BOOKING") }}</h4>
      </div>
      <div class="grid-body border-top-unset" id="list-booking-transaction">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <div>
          <div class="card-item">
            <div class="p-3">
              <div class="search-box">
                <v-btn @click="searchByCode()" outlined class="search-icon-left">
                  <svg focusable="false" height="24px" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.49,19l-5.73-5.73C15.53,12.2,16,10.91,16,9.5C16,5.91,13.09,3,9.5,3S3,5.91,3,9.5C3,13.09,5.91,16,9.5,16 c1.41,0,2.7-0.47,3.77-1.24L19,20.49L20.49,19z M5,9.5C5,7.01,7.01,5,9.5,5S14,7.01,14,9.5S11.99,14,9.5,14S5,11.99,5,9.5z"></path><path d="M0,0h24v24H0V0z" fill="none"></path>
                  </svg>
                </v-btn>
                <input v-model="bookingCodeSearch" @keyup.enter="searchByCode()"  type="text" :placeholder="$t('_BOOKING.ENTER_BOOKING_CODE')" />
                <v-btn outlined @click="openPopup()" class="search-icon-right">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"></path></svg>
                </v-btn>
              </div>
            </div>
            <div class="overlay-search" @click="openPopup()" v-if="isShowPopup"></div>
            <div class="popup-search p-3" v-if="isShowPopup">
              <b-row>
                <b-col  md="6" class="py-0 pr-0">
                  <label class="label-input">{{$t("_BOOKING_TRANSACTION.SEARCH_CONDITION")}}</label>
                  <select-text
                    :items="listSearchCondition"
                    :id.sync="selectedSearchConditionId"
                    @change="changeSearchCondition"
                  />
                </b-col>
                <b-col md="6" v-if="selectedSearchConditionId === 2 || selectedSearchConditionId === 3 || selectedSearchConditionId === 4 || selectedSearchConditionId === 1" :class="selectedSearchConditionId === 1 ? 'py-0' : 'py-1'">
                  <div v-if="selectedSearchConditionId === 1">
                    <label class="label-input">{{$t("_BOOKING_TRANSACTION.SEARCH_BOOKING_CODE")}}</label>
                    <input-text :regex="REGEX_NUMBER" :model.sync="paging.code" />
                  </div>
                  <div
                    v-if="selectedSearchConditionId === 2 || selectedSearchConditionId === 3 || selectedSearchConditionId === 4"
                  >
                    <label class="label-input">{{$t("_BOOKING_TRANSACTION.SEARCH_DATE")}}</label>
                    <div class="d-flex justify-content-between w-100">
                      <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"  class="w-100"
                        :popup-class="'popup-calendar-desktop-detailhotel'" 
                        v-model="dateRange" 
                        :lang="languageDate" 
                        :format="selectedSearchConditionId === 2 ? 'DD/MM/YYYY HH:mm:ss' : 'DD/MM/YYYY'" 
                        :type="selectedSearchConditionId === 2 ? 'datetime' : 'date'" 
                        :editable="false"
                        :shortcuts=[] range placeholder="Select date range">
                      </date-picker>
                    </div>
                    </div>
                </b-col>
                <b-col md="6" v-if="selectedSearchConditionId === 5" class="py-1">
                  <label class="label-input">{{  $t("_BOOKING.SEARCH_BY.STAYING_DATE")}}</label>
                  <div class="d-flex justify-content-between">
                        <date-picker :confirm-text="$t('CONFIRM')" :clearable="false"
                          :popup-class="'popup-calendar-desktop-detailhotel'" v-model="stayDate" :lang="languageDate"
                          :format="'DD/MM/YYYY'" :editable="false" :shortcuts=[] :range="false" placeholder="Select date">
                        </date-picker>
                      </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6" class="pr-0">
                  <label class="label-input">{{$t("BOOKING_CHANNEL")}}</label>
                    <!-- <select-text
                    :items="listSelectOTA"
                    :id.sync="paging.otaId"
                  /> -->
                  <v-autocomplete
                    dense
                    outlined
                    item-text="text"
                    item-value="value"
                    :items="listSelectOTA"
                    v-model="paging.otaIds"
                    multiple
                    ref="otaIds"
                  >
                  <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                          @click="paging.otaIds = [...new Set(paging.otaIds.concat($refs['otaIds'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                          class="text-primary" @click="paging.otaIds = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, paging.otaIds)" @click="item.select">
                        <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ paging.otaIds.length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </b-col>
                <b-col md="6">
                  <label class="label-input">{{$t("_BOOKING_TRANSACTION.BOOKING_STATUS")}}</label>
                  <v-autocomplete
                    dense
                    outlined
                    item-text="text"
                    item-value="value"
                    :items="listBookingStatus"
                    v-model="paging.status"
                    chips
                    multiple
                    ref="status"
                  >
                    <template v-slot:prepend-item>
                      <p class="mx-3 mt-1"> <a class="text-primary"
                          @click="paging.status = [...new Set(paging.status.concat($refs['status'].filteredItems.map(e => e.value)))]">{{ $t('SELECT_ALL') }}</a> | <a
                          class="text-primary" @click="paging.status = []">{{ $t('UN_SELECT_ALL') }}</a>
                      </p>
                    </template>

                    <template v-slot:selection="{ item, index }">
                      <v-chip color="primary" v-if="index === 0" v-bind="item.attrs" :input-value="item.selected" close
                        @click:close="remove(index, paging.status)" @click="item.select">
                        <p class="mb-0 text-truncate" style="max-width: 150px">{{ item.text }}</p>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">(+{{ paging.status.length - 1 }})</span>
                    </template>
                    <template slot="no-data">
                      <div class="no-data">{{ $t("NO_DATA") }}</div>
                    </template>
                  </v-autocomplete>
                </b-col>
              </b-row>
              <!-- End coding -->
              <div class="d-flex justify-end align-items-end flex-wrap py-0 mb-2">
                <div class="mr-3 reset">
                  <v-btn class="pl-5 pr-5" @click="reset()">
                      <v-icon size="20" left>
                        mdi-refresh
                      </v-icon>
                      {{ $t("_BOOKING.RESET") }}
                  </v-btn>
                </div>
                <div class="mr-3">
                  <v-btn color="primary" @click="getAll(true)" class="main-btn btn-pmirary" >
                    <v-icon size="20" left>
                      search
                    </v-icon>
                    {{$t('_BOOKING_TRANSACTION.SEARCH')}}
                  </v-btn>
                </div>
              </div>
            </div>
              <!-- End -->
              <!-- button scroll -->
              <div ref="containerCondition" class="container-condition py-4 pt-0">
                <div class="d-flex align-items-center">
                  <button
                    v-if="isShowArrow"
                    class="left round"
                    @click="scrollLeft"
                  >
                  <v-icon>mdi-chevron-left</v-icon>
                  </button>
                  
                  <div ref="scrollContainer" class="overflow-auto scroll-container">
                    <div v-if="conditionSearch === 2" class="d-inline-flex gap-3">
                      <label class="" :title="conditionSearch === 2 && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 2 && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                          {{ this.$t("_BOOKING.SEARCH_BY.BOOKING_DATE") }} {{ conditionSearch === 2 && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                        </div>
                      </label>
                    </div>

                    <div v-if="conditionSearch === 3" class="d-inline-flex gap-3">
                      <label class="" :title="conditionSearch === 3 && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 3 && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                          {{ this.$t("_BOOKING.SEARCH_BY.CHECKIN_DATE") }} {{ conditionSearch === 3 && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                        </div>
                      </label>
                    </div>

                    <div v-if="conditionSearch === 4" class="d-inline-flex gap-3">
                      <label class="" :title="conditionSearch === 4 && conditionDateRange[0] ? formatDate(conditionSearch, conditionDateRange) : ''">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 4 && conditionDateRange[0] && !isClear ? 'active-condition' : ''">
                          {{ this.$t("_BOOKING.SEARCH_BY.CHECKOUT_DATE") }} {{ conditionSearch === 4 && conditionDateRange[0] && !isClear ? ': '+ formatDate(conditionSearch, conditionDateRange) : ''  }}
                        </div>
                      </label>
                    </div>

                    <div v-if="conditionSearch === 5" class="d-inline-flex gap-3">
                      <label class="" :title="conditionStayDate ? formatDate(conditionSearch, conditionStayDate) : ''">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="conditionSearch === 5 && conditionStayDate && !isClear? 'active-condition' : ''">
                          {{ this.$t("_BOOKING.SEARCH_BY.STAYING_DATE") }} {{ conditionSearch === 5 && conditionStayDate && !isClear ? ': '+ formatDate(conditionSearch, conditionStayDate) : ''  }}
                        </div>
                      </label>
                    </div>

                    <div v-if="listNameOTA && listNameOTA.length > 0" class="d-inline-flex gap-3">
                      <label :title="listNameOTA.join('\n')">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameOTA.length > 0 && !isClear ? 'active-condition' : ''">
                          {{ $t("BOOKING_CHANNEL") }} {{ listNameOTA.length > 0 && !isClear ? (listNameOTA.length > 1 ? ': ' + listNameOTA[0]+'...' : ': ' + listNameOTA[0]) : ''  }}
                        </div>		
                      </label>
                    </div>

                    <div v-if="listNameBKStatus && listNameBKStatus.length > 0" class="d-inline-flex gap-3">
                      <label :title="listNameBKStatus.join('\n')">
                        <div class="border p-1 pl-2 pr-2 mr-3 rounded" :class="listNameBKStatus.length > 0 && !isClear ? 'active-condition' : ''">
                          {{ $t("_BOOKING_TRANSACTION.BOOKING_STATUS") }} {{ listNameBKStatus.length > 0 && !isClear ? (listNameBKStatus.length > 1 ? ': ' + listNameBKStatus[0]+'...' : ': ' + listNameBKStatus[0]) : ''  }}
                        </div>		
                      </label>
                    </div>
                  </div>
                  <button
                    v-if="isShowArrow"
                    class="right round"
                    @click="scrollRight"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                  </button>
                </div>
              </div>
              <!-- button scroll -->
              <v-progress-linear class="custom-progress" color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
            <v-data-table
              :headers="headers"
              :items="data"
              :items-per-page="data.length"
              disable-sort
              hide-default-footer
              item-key="id"
              class="main-table"
            >
              <template slot="no-data">
                <span>{{$t("HAS_NO_DATA")}}</span>
              </template>
              <template v-slot:item.index="{ item, index }">{{ paging.offset + index + 1 }}</template>
              <template v-slot:item.bookedDate="{ item }">
                <span class="text-nowrap">{{utcConvertToLocalTimeZone(item.createdDate)}}</span>
              </template>
              <template v-slot:item.bookingCode="{ item }">
                <a
                  class="app-link"
                  href="javascript:;"
                  @click="goToBookingDetail(item.bookingCode)"
                >{{item.bookingCode}}</a>
              </template>
              <template v-slot:item.ota="{ item }">
                <span v-if="item.local" class="d-block">{{item.local.name}}</span>
              </template>
              <template v-slot:item.timeStay="{ item }">
                <span class="d-block">{{item.checkIn}} - {{item.checkOut}}</span>
                <span
                  v-if="item.timeStay"
                  class="d-block mt-1 app-secondary-text"
                >{{$t('_BOOKING_TRANSACTION.TIME_STAY_TEXT', { day: item.timeStay + 1, night: item.timeStay })}}</span>
              </template>
              <template v-slot:item.amount="{ item }">
                <span>
                    {{ formatCurrency(item.amount, item.currencyCode) }}
                </span>
              </template>
              <template v-slot:item.bookingPayments="{ item }">
                <div
                  v-for="(pay, i) in item.bookingPayments"
                  :key="i"
                  class="payment"
                  :class="getPaymentClass(pay.paymentStatus)"
                >
                  <span class="date">{{_formatDateTimeUTCToLocal(pay.paymentDeadline, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY')}}</span>
                  <span class="amount d-block mt-1">{{formatCurrency(pay.amount, item.currencyCode)}}</span>
                </div>
              </template>
              <template v-slot:item.bookingStatus="{ item }">
                <span :style="{color: getStatusColor(item.bookingStatus)}">{{getStatusText(item.bookingStatus)}}</span>
              </template>
              <template v-slot:item.paymentCollectType="{ item }">
                {{ 
                  item.paymentCollectType === 0 
                    ? $t("_BOOKING_DETAIL.PROPERTY_COLLECT") 
                    : item.paymentCollectType === 1 
                      ? $t("_BOOKING_DETAIL.OTA_CONTACT") 
                      : $t("_BOOKING_DETAIL.CHANNEL_COLLECT") 
                }}
              </template>
              <template v-slot:item.action="{ item }">
                <a
                  class="app-link"
                  href="javascript:;"
                  @click="goToConfirmBooking(item)"
                >{{$t("_BOOKING_TRANSACTION.CONFIRM")}}</a>
              </template>
            </v-data-table>
            <v-row
              class="mt-2 mx-3"
              align="center"
              justify="center"
            >
              <span class="grey--text">{{  $t('ITEMS_PER_PAGE') }}</span>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    dark
                    text
                    color="primary"
                    class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    {{ paging.limit }}
                    <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(number, index) in itemsPerPageArray"
                    :key="index"
                    @click="paging.limit = number; getAll(true)"
                  >
                    <v-list-item-title>{{ number }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-spacer></v-spacer>

              <paging class="px-3" v-if="paging && paging.total" :paging.sync="paging" @changePage="changePage">
                <span
                  slot="totalItems"
                >{{$t("TOTAL")}}: {{paging.total}} {{$t("_BOOKING_TRANSACTION.BOOKING")}}</span>
              </paging>
            </v-row>
           
          </div>
        </div>
      </div>
      <v-navigation-drawer
        v-model="showDetail"
        absolute
        temporary
        right
        width="1000"
        >
        <booking-detail 
        v-if="showDetail" 
        :code="code" 
        @close="()=> {showDetail = false}"
        @reload="()=> {showDetail = false; reload()}"
        ></booking-detail>
      </v-navigation-drawer>
      <v-navigation-drawer
        v-model="showTransactionDetail"
        absolute
        temporary
        right
        width="800"
        >
        <transaction-detail 
        v-if="showTransactionDetail" 
        :item="item" 
        @close="()=> {showTransactionDetail = false}"
        @reload="()=> {showTransactionDetail = false; reload()}"
        ></transaction-detail>
      </v-navigation-drawer>
    </div>
  </v-app>
</template>

<style lang="scss" scoped>
#list-booking-transaction {
  .payment {
    &:not(:first-child) {
      margin-top: 5px;
    }
    .date {
      padding: 3px;
      border-radius: 5px;
    }
    .amount {
      padding-left: 3px;
    }
    &.payed {
      .date {
        color: #ffffff;
        background-color: #808080;
      }
      .amount {
        color: #808080;
      }
    }
    &.notpay {
      .date {
        color: #ffffff;
        background-color: #173d8f;
      }
      .amount {
        color: #173d8f;
      }
    }
    &.expired {
      .date {
        color: #ffffff;
        background-color: #fed12f;
      }
      .amount {
        color: #fed12f;
      }
    }
  }
}
.col-12 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}
.cols-4 {
  -webkit-box-flex: 0;
    -ms-flex: 0 0 27%;
    flex: 0 0 27%;
    max-width: 27%
}

</style>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
import Paging from "@/components/Utils/Paging.vue";
import DateRange from "@/components/Utils/DateRange.vue";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import {
  _alert,
  _formatDateTime,
  _formatCurrency, 
  _formatDateTimeUTCToLocal
} from "@/_helpers/function.js";
import { service } from "@/_services/Booking/booking.service.js";
import { syncota } from "@/_services/SyncOTA/syncota.js";
import moment from "moment";
import FileSaver from "file-saver";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import BookingDetail from '../../Booking/BookingDetail.vue';
import TransactionDetail from './TransactionDetail.vue';

export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu,
    "input-text": Input,
    "select-text": Select,
    "date-picker": DatePicker,
    "date-range": DateRange,
    paging: Paging,
    DateRangePicker,
    BookingDetail,
    TransactionDetail,
  },
  data() {
    return {
      isLoading: false,
      locale_data: {
        format: 'YYYY-MM-DD',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        daysOfWeek: [this.$t("_DATE_RANGE.SUNDAY"), this.$t("_DATE_RANGE.MONDAY"), this.$t("_DATE_RANGE.TUESDAY"), this.$t("_DATE_RANGE.WEDNESDAY"), this.$t("_DATE_RANGE.THURSDAY"), this.$t("_DATE_RANGE.FRIDAY"), this.$t("_DATE_RANGE.SATURDAY")],
        monthNames: [this.$t("_DATE_RANGE.JAN"), this.$t("_DATE_RANGE.FEB"), this.$t("_DATE_RANGE.MAR"), this.$t("_DATE_RANGE.APR"), this.$t("_DATE_RANGE.MAY"), this.$t("_DATE_RANGE.JUN"), this.$t("_DATE_RANGE.JUL"), this.$t("_DATE_RANGE.AUG"), this.$t("_DATE_RANGE.SEP"), this.$t("_DATE_RANGE.OTC"), this.$t("_DATE_RANGE.NOV"), this.$t("_DATE_RANGE.DEC")],
        firstDay: 1
      },
      dateRange: [],
      stayDate: null,
      headers: [
        {
          text: this.$t("STT"),
          align: "center",
          value: "index"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.BOOKING_DATE"),
          align: "left",
          value: "bookedDate",
          width: "10%"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.BOOKING_CODE"),
          align: "left",
          value: "bookingCode",
          width: "120px"
        },
        {
          text: this.$t("BOOKING_CHANNEL"),
          align: "left",
          value: "ota"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.TIME_STAY"),
          align: "left",
          value: "timeStay",
          width: "15%"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.AMOUNT"),
          align: "right",
          value: "amount",
          width: "12%"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.PAYMENT_DATE"),
          align: "right",
          value: "bookingPayments",
          width: "15%"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.BOOKING_STATUS"),
          align: "center",
          value: "bookingStatus",
          width: "14%"
        },
        {
          text: this.$t("_BOOKING_DETAIL.PAYMENT_COLLECT"),
          align: "center",
          value: "paymentCollectType",
          width: "14%"
        },
        {
          text: this.$t("_BOOKING_TRANSACTION.ACTION"),
          align: "center",
          value: "action",
          width: "10%"
        }
      ],
      data: [],
      selectedSearchConditionId: 2,
      listSearchCondition: [
        {
          id: 1,
          key: "BOOKING_CODE",
          value: this.$t("_BOOKING_TRANSACTION.SEARCH_BY.BOOKING_CODE")
        },
        {
          id: 2,
          key: "BOOKING_DATE",
          value: this.$t("_BOOKING_TRANSACTION.SEARCH_BY.BOOKING_DATE")
        },
        {
          id: 3,
          key: "CHECKIN_DATE",
          value: this.$t("_BOOKING_TRANSACTION.SEARCH_BY.CHECKIN_DATE")
        },
        {
          id: 4,
          key: "CHECKOUT_DATE",
          value: this.$t("_BOOKING_TRANSACTION.SEARCH_BY.CHECKOUT_DATE")
        },
        {
          id: 5,
          key: "STAY_DATE",
          value: this.$t("_BOOKING.SEARCH_BY.STAYING_DATE")
        }
      ],
      selectedBookingStatusId: -1,
      listBookingStatus: [
        {
          id: 2,
          value: 0,
          text: this.$t("_BOOKING.STATUS.AWAIT_PAYMENT"),
          color: "rgb(254, 209, 47)"
        },
        {
          id: 3,
          value: 6,
          text: this.$t("_BOOKING.STATUS.PAYMENT_FAILED"),
          color: "#ff0000"
        },
        {
          id: 4,
          value: 7,
          text: this.$t("_BOOKING.STATUS.AWAIT_FULLY_PAYMENT"),
          color: "#fed12f"
        }
      ],
       listSelectOTA: [],
      paging: {
        total: 0,
        limit: 15,
        offset: 0,
        lang: localStorage.getItem("defaultLanguage") || "vi",
        searchBy: null,
        from: null,
        to: null,
        code: null,
        otaIds: [],
        status: [0, 6, 7]
      },
      systemLang: this.$i18n.locale,
      showDetail: false,
      code: null,
      currentRoute: this.$route.path,
      showTransactionDetail: false,
      item: null,
      bookingSegments: [],
      isShowPopup: false,
      isScrollLeftDisabled: true,
      isScrollRightDisabled: false,
      listNameOTA: [],
      listNameBKStatus: [],
      conditionStayDate: null,
      conditionDateRange: [],
      conditionSearch: 2,
      bookingCodeSearch: '',
      isClear: true,
      widthScroll: 0,
      widthContainer: 0,
      resizeObserver: null,
      isShowArrow: false
    };
  },
  computed: {
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    }
  },
  mounted(){
    this.initialize();
    this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
            if (entry.target === this.$refs.scrollContainer) {
            this.widthScroll = entry.contentRect.width;
            } else if (entry.target === this.$refs.containerCondition) {
            this.widthContainer = entry.contentRect.width;
            }
        }
    });
    this.resizeObserver.observe(this.$refs.scrollContainer);
    this.resizeObserver.observe(this.$refs.containerCondition);
  },
  beforeDestroy() {
      if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      }
  },
  created() {
    let searchHistoryListOfTransaction = sessionStorage.getItem('searchHistoryListOfTransaction');
    if (searchHistoryListOfTransaction) {
      searchHistoryListOfTransaction = JSON.parse(searchHistoryListOfTransaction);
      this.selectedSearchConditionId = searchHistoryListOfTransaction.selectedSearchConditionId;
      this.dateRange = [
        new Date(searchHistoryListOfTransaction.dateRange[0]), 
        new Date(searchHistoryListOfTransaction.dateRange[1])
      ];
      this.stayDate = new Date(searchHistoryListOfTransaction.stayDate);
      this.paging = searchHistoryListOfTransaction.paging;
      this.paging.offset = 0;
    } else {
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today, day1];
      this.stayDate = new Date(moment().format('YYYY-MM-DD'));
    }
  },
  methods: {
    reload() {
      history.pushState(null, '', `${this.currentRoute}`);
      this.initialize();
    },
    remove(index, array) {
      array.splice(index, 1);
      this.$forceUpdate();
    },
     _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
      if (!value) {
        return "";
      }
      return _formatDateTimeUTCToLocal(value, inputFormat, outputFormat);
    },
    formatDateTime(value, inputFormat, outputFormat) {
      return _formatDateTime(value, inputFormat, outputFormat);
    },
    formatCurrency(amount, currencyCode) {
      return _formatCurrency(amount, currencyCode);
    },
    getStatusColor(status) {
      const selected = this.listBookingStatus.find(item => item.value === status);
      return selected ? selected.color : status;
    },
    getStatusText(status) {
      const selected = this.listBookingStatus.find(item => item.value === status);
      return selected ? selected.text : status;
    },
    getPaymentClass(status) {
      let classText = "";
      if (status === 0) {
        classText = "payed";
      } else if (status === 1) {
        classText = "notpay";
      } else if (status === 2) {
        classText = "expired";
      }
      return classText;
    },
    // Run when start
    initialize() {
      let body = {
        keyword: "",
        status: 1
      };
      syncota.getAllOTA(body).then(res => {
        if (res.responseCode === 0) {
          res.data.forEach(x => {
            this.listSelectOTA.push({
                value: x.id,
                text: x.otaI18n.find(y => y.lang == this.defaultI18n).name
              });
            });
            this.listSelectOTA.sort((a, b) => a.text.localeCompare(b.text));
            this.paging.otaIds = this.listSelectOTA.map(e => e.value)
           this.changeSearchCondition();
          // Call service
          this.getAll();
        } else {
          _alert(res, this.$t(res.data), false);
        }
      });
    },
    // Change page
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    // Reset
    reset() {
      this.selectedSearchConditionId = 2;
      const today = new Date();
      today.setHours(0);
      today.setMinutes(0);
      today.setSeconds(0);
      const day1 = new Date(moment().add(1, 'day'));
      day1.setHours(0);
      day1.setMinutes(0);
      day1.setSeconds(0);
      this.dateRange = [today,day1];
      this.paging.otaIds = this.listSelectOTA.map(e => e.value);
      this.paging.status = this.listBookingStatus.map(e => e.value);
    },
    // Get all booking transaction
    getAll(isSearching) {
      this.bookingCodeSearch = '';
      this.mapValuesOTA();
      this.mapValuesBKStatus();
      this.conditionStayDate = this.stayDate;
      this.conditionDateRange = this.deepCopyArrayWithDates(this.dateRange);
      this.conditionSearch = this.selectedSearchConditionId;
      this.isShowPopup = false;
      const selectedItem = this.listSearchCondition.find(
        item => item.id === this.selectedSearchConditionId
      );
      this.paging.searchBy = selectedItem ? selectedItem.key : null;
      this.isClear = false;
      
      if (this.paging.searchBy === null || this.paging.searchBy === 'BOOKING_DATE' || this.paging.searchBy === 'CHECKIN_DATE' || this.paging.searchBy === 'CHECKOUT_DATE') {
        if (this.isSixMonthsOrLess(this.paging.from, this.paging.to) === 1) {
          _alert(null, this.$t("PLEASE_SELECT_DATE_LESS_6_MONTH"));
          return
        }
      }
      if ((this.paging.searchBy === 'BOOKING_CODE_OTA' || this.paging.searchBy === 'BOOKING_CODE') && !this.paging.code) {
        this.paging.total = 0;
        this.data = [];
        return
      }
      const locale = localStorage.getItem("defaultLanguage") || "vi";
      const today = moment().startOf("day");
      const tomorrow = moment()
        .startOf("day")
        .add(1, "day");
      const yesterday = moment()
        .startOf("day")
        .subtract(1, "day");
      if (isSearching) this.paging.offset = 0;
      this.isLoading = true;
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        otaIds: this.paging.otaIds === -1 ? null : this.paging.otaIds,
        status: this.paging.status.length === 0 ? null : this.paging.status,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      }
      service
        .getAllTransaction(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data.map(item => {
              // Mapping bookedDay
              const bookedDay = moment.utc(
                item.createdDate,
                "YYYY-MM-DD HH:mm:ss"
              ).local().startOf("day");
              let bookedDayText = bookedDay.format("DD/MM/YY");
              if (bookedDay.diff(today, "days") === 0) {
                bookedDayText = this.$t("TODAY").toString();
              } else if (bookedDay.diff(tomorrow, "days") === 0) {
                bookedDayText = this.$t("TOMORROW").toString();
              } else if (bookedDay.diff(yesterday, "days") === 0) {
                bookedDayText = this.$t("YESTERDAY").toString();
              }
              item.bookedDateDay = bookedDayText;
              // const bookedTime = moment(item.createdDate, "YYYY-MM-DD HH:mm:ss").utc().local();
              const bookedTime = moment.utc(item.createdDate, "YYYY-MM-DD HH:mm:ss").local();
              item.bookedDateTime = bookedTime.format("HH:mm");
              // Mapping agenyName
              let local = item.ota.otaI18n.find(itemData => itemData.lang === locale);
              if (!local && item.ota.otaI18n.length > 0) {
                local = item.ota.otaI18n[0];
              }
              item.local = local;
              // Mapping timeStay
              const checkIn = moment(item.arrival, "YYYY-MM-DD");
              const checkOut = moment(item.departure, "YYYY-MM-DD");
              const duration = checkOut.diff(checkIn, "days");
              item.checkIn = checkIn.format("DD/MM/YYYY");
              item.checkOut = checkOut.format("DD/MM/YYYY");
              item.timeStay = duration;
              return item;
            });
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    searchByCode() {
      this.conditionDateRange = [];
      this.listNameOTA = [];
      this.listNameBKStatus = [];
      this.paging.searchBy = 'BOOKING_CODE';
      if (this.paging.searchBy === 'BOOKING_CODE' && !this.bookingCodeSearch) {
        this.paging.total = 0;
        this.data = [];
        return
      }
      this.isClear = true;
      const locale = localStorage.getItem("systemLanguage") || "vi";
      const today = moment().startOf("day");
      const tomorrow = moment()
        .startOf("day")
        .add(1, "day");
      const yesterday = moment()
        .startOf("day")
        .subtract(1, "day");
      this.isLoading = true;
      const body = {
        limit: this.paging.limit,
        offset: this.paging.offset,
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.bookingCodeSearch,
        otaIds: [],
        status: null,
        stayDate: null
      }
      service
        .getAllTransaction(body)
        .then(res => {
          if (res.responseCode === 0) {
            this.paging.total = res.total;
            this.data = res.data.map(item => {
              // Mapping bookedDay
              const bookedDay = moment.utc(
                item.createdDate,
                "YYYY-MM-DD HH:mm:ss"
              ).local().startOf("day");
              let bookedDayText = bookedDay.format("DD/MM/YY");
              if (bookedDay.diff(today, "days") === 0) {
                bookedDayText = this.$t("TODAY").toString();
              } else if (bookedDay.diff(tomorrow, "days") === 0) {
                bookedDayText = this.$t("TOMORROW").toString();
              } else if (bookedDay.diff(yesterday, "days") === 0) {
                bookedDayText = this.$t("YESTERDAY").toString();
              }
              item.bookedDateDay = bookedDayText;
              // const bookedTime = moment(item.createdDate, "YYYY-MM-DD HH:mm:ss").utc().local();
              const bookedTime = moment.utc(item.createdDate, "YYYY-MM-DD HH:mm:ss").local();
              item.bookedDateTime = bookedTime.format("HH:mm");
              // Mapping agenyName
              let local = item.ota.otaI18n.find(itemData => itemData.lang === locale);
              if (!local && item.ota.otaI18n.length > 0) {
                local = item.ota.otaI18n[0];
              }
              item.local = local;
              // Mapping timeStay
              const checkIn = moment(item.arrival, "YYYY-MM-DD");
              const checkOut = moment(item.departure, "YYYY-MM-DD");
              const duration = checkOut.diff(checkIn, "days");
              item.checkIn = checkIn.format("DD/MM/YYYY");
              item.checkOut = checkOut.format("DD/MM/YYYY");
              item.timeStay = duration;
              return item;
            });
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // Change search condition
    changeSearchCondition() {
      const selectedItem = this.listSearchCondition.find(
        item => item.id === this.selectedSearchConditionId
      );
      this.paging.searchBy = selectedItem ? selectedItem.key : null;
    },
    // Go to booking detail page
    goToBookingDetail(code) {
      this.code = code;
      let searchHistoryListOfTransaction = {
        selectedSearchConditionId: JSON.parse(JSON.stringify(this.selectedSearchConditionId)),
        paging: JSON.parse(JSON.stringify(this.paging)),
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        stayDate: JSON.parse(JSON.stringify(this.stayDate)),
      };
      sessionStorage.setItem('searchHistoryListOfTransaction', JSON.stringify(searchHistoryListOfTransaction));
      const routeInfo = this.$router.resolve({ 
        name: "bookingDetail",
        params: { code: code } 
      });
      history.pushState(null, '', routeInfo.href);
      this.showDetail = true;
    },
    // Go to confirm booking
    goToConfirmBooking(item) {
      this.item = item;
      let searchHistoryListOfTransaction = {
        selectedSearchConditionId: JSON.parse(JSON.stringify(this.selectedSearchConditionId)),
        paging: JSON.parse(JSON.stringify(this.paging)),
        dateRange: JSON.parse(JSON.stringify(this.dateRange)),
        stayDate: JSON.parse(JSON.stringify(this.stayDate)),
      };
      sessionStorage.setItem('searchHistoryListOfTransaction', JSON.stringify(searchHistoryListOfTransaction));
      const routeInfo = this.$router.resolve({ 
        name: "transactionDetail",
        params: { item: item } 
      });
      sessionStorage.setItem('item', JSON.stringify(item));
      history.pushState(null, '', routeInfo.href);
      this.showTransactionDetail = true;
    },
    // Export transaction
    exportTransaction() {
      this.isLoading = true;
      let param = {
        lang: this.paging.lang,
        searchBy: this.paging.searchBy,
        from: this.paging.from,
        to: this.paging.to,
        code: this.paging.code,
        otaIds: this.paging.otaIds === -1 ? null : this.paging.otaIds,
        status: this.paging.status.length === 0 ? null : this.paging.status,
        stayDate: moment(this.stayDate).format('YYYY-MM-DD')
      };
      service
        .exportTransaction(param)
        .then(res => {
          if (res.responseCode === 0) {
            const url = res.data;
            FileSaver.saveAs(url);
          } else {
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    openPopup() {
      this.isShowPopup = !this.isShowPopup;
    },
    scrollLeft() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
        left: -200,
        behavior: "smooth",
      });
    },
    scrollRight() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
        left: 200,
        behavior: "smooth",
      });
    },
    
    formatDate(condition, dateRage) {
      var dateStart = moment(dateRage[0], "YYYY-MM-DD");
      var dateEnd = moment(dateRage[1], "YYYY-MM-DD");
      if (condition === 2) {
        return dateStart.format("DD/MM/YYYY HH:mm:ss") + ' ~ ' + dateEnd.format("DD/MM/YYYY HH:mm:ss");
      } else if (condition === 5) {
        return moment(dateRage, "DD/MM/YYYY").format("DD/MM/YYYY");
      } else {
        return dateStart.format("DD/MM/YYYY")+ ' ~ ' + dateEnd.format("DD/MM/YYYY");
      }
    },
    mapValuesOTA() {       
      this.listNameOTA = this.paging.otaIds.map(id => {
        const matchedItem = this.listSelectOTA.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    mapValuesBKStatus() { 
      this.listNameBKStatus = this.paging.status.map(id => {
        const matchedItem = this.listBookingStatus.find(item => item.value === id); 
        return matchedItem ? matchedItem.text : null; 
      }).filter(item => item !== null)
    },
    _moment: moment
  },
  watch: {
    showDetail() {
        if(this.showDetail == false) {
            history.pushState(null, '', `${this.currentRoute}`);
        }
    },
    dateRange(){
      this.paging.from = this.dateRange[0];
      this.paging.to = this.dateRange[1];
    },
    widthScroll() {
      if (this.widthScroll + 50 > this.widthContainer) {
          this.isShowArrow = true;
      } else {
          this.isShowArrow = false;
      }
    }
  }
};
</script>